import React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import { ErrorPage, GenericPage, Login, Outdoor } from "../../pages/";
import { Layout } from "../../root";
import {
  modelsRoute,
  userRoute,
  resourcesRoute,
  stockifyRoutes,
  optionsRoute,
  administrationRoutes,
  finanzasRoutes,
  configurationRoutes,
  sriRoutes,
} from "../routes";
import SubscriptionBlockedPage from "../../pages/lib/subscription-blocked";

const Dashboard = React.lazy(() => import("../../pages/lib/dashboard/page"));
const GenericExteriorPage = React.lazy(
  () => import("../../pages/lib/exterior-page/page"),
);

export const router = createBrowserRouter([
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/exterior",
    element: <Outdoor />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "container/*",
        element: <GenericExteriorPage />,
        errorElement: <ErrorPage />,
      },
    ],
  },
  {
    path: "/subscription-blocked",
    element: <SubscriptionBlockedPage />,
  },
  {
    path: "/",
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "administration",
        errorElement: <ErrorPage />,
        children: administrationRoutes,
      },
      {
        path: "configuration",
        errorElement: <ErrorPage />,
        children: configurationRoutes,
      },
      {
        path: "dashboard",
        element: <Dashboard />,
        errorElement: <ErrorPage />,
      },

      {
        path: "finanzas",
        errorElement: <ErrorPage />,
        children: finanzasRoutes,
      },
      {
        path: "models",
        errorElement: <ErrorPage />,
        children: modelsRoute,
      },
      {
        path: "options",
        errorElement: <ErrorPage />,
        children: optionsRoute,
      },

      {
        path: "user",
        element: <GenericPage />,
        errorElement: <ErrorPage />,
        children: userRoute,
      },
      {
        path: "resources",
        errorElement: <ErrorPage />,
        children: resourcesRoute,
      },
      {
        path: "stockify",
        errorElement: <ErrorPage />,
        children: stockifyRoutes,
      },
      {
        path: "sri",
        errorElement: <ErrorPage />,
        children: sriRoutes,
      },

      {
        path: "",
        element: <Navigate replace to="dashboard" />,
      },
    ],
  },
  {
    path: "",
    element: <Login />,
  },
]);
